"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ProductsFilter = require("./ProductsFilter");

Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ProductsFilter).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }